<!-- 订单编辑界面 -->
<template>
    <el-dialog
            :title="title"
            :lock-scroll="false"
            :visible.sync="show"
            :modal="true"
            @closed="closed"
            width="55%">
        <!-- 表单数据 -->
        <el-form ref="applyForm" :rules="rules" :inline="true" label-position="left" :model="modelData"
                 label-width="auto">
            <el-form-item :rules="rules.select" prop="current" label="面料状态:" size="mini">
                <el-select :popper-append-to-body="false"
                           v-model="modelData.current" placeholder="面料状态">
                    <template v-for="(currentStatus,index) in currentStatusArray">
                        <el-option :key="index" :label="currentStatus[1]" :value="currentStatus[0]"></el-option>
                    </template>
                </el-select>
            </el-form-item>

            <el-form-item :rules="rules.date" prop="estimate_date" label="面料预计入库日期:" size="mini">
                <el-date-picker
                        v-model="modelData.estimate_date"
                        type="date"
                        placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item :rules="rules.select" prop="sub_current" label="辅料状态:" size="mini">
                <el-select :popper-append-to-body="false"
                           v-model="modelData.sub_current" placeholder="辅料状态">
                    <template v-for="(currentStatus,index) in currentStatusArray">
                        <el-option :key="index" :label="currentStatus[1]" :value="currentStatus[0]"></el-option>
                    </template>
                </el-select>
            </el-form-item>

            <el-form-item :rules="rules.date" prop="sub_material_estimate_date" label="辅料预计入库日期:" size="mini">
                <el-date-picker
                        v-model="modelData.sub_material_estimate_date"
                        type="date"
                        placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
        </el-form>

        <!-- 功能栏 -->
        <el-row class="__button-row">
            <el-button :loading="updateLoading" @click="updateClick" size="mini" type="primary">保 存</el-button>
        </el-row>

        <!-- footer  -->
        <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="close">取 消</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import {mapState, mapMutations, mapGetters} from 'vuex'
    import moment from 'moment'

    export default {
        name: "OrderApplyModify",
        data() {
            // 日期验证器
            // 验证日期必须大于当前日期
            const dataValidator = (rule, value, callback) => {
                if (!(value instanceof Date)) {
                    value = new Date(Date.parse(value))
                }
                const now = new Date()

                now.setSeconds(0)
                now.setMinutes(0)
                now.setHours(0)
                now.setMilliseconds(0)
                if (now.getTime() > value.getTime()) {
                    callback(new Error('必须大于当前时间'));
                } else {
                    callback();
                }
            }

            // 必选验证器
            // 验证属性值为必选项
            const requiredValidator = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('必填项'));
                } else {
                    callback();
                }
            }

            return {
                // 是否显示`加载中...`图标
                show: false,

                // 点击保存的 loading
                updateLoading: false,

                // 表单验证数据
                modelData: {
                    sub_material_estimate_date: '',
                    estimate_date: '',
                    sub_current: '',
                    current: '',
                },

                // 解析/输出 日期格式
                dateFormat: this.$const.dateFormat,

                // current 选项
                currentStatusArray: [
                    ['WAIT', '待采购'],
                    ['HANDLE', '采购中'],
                    ['FINISH', '完成'],
                ],

                // 表单的验证规则
                rules: {
                    date: [
                        {validator: requiredValidator, trigger: 'blur'},
                        {validator: dataValidator, trigger: 'blur'}
                    ],
                    select: [
                        {validator: requiredValidator, trigger: 'blur'},
                    ]
                },
            }
        },
        computed: {
            /**
             * form 表单
             */
            formComponent() {
                return this.$refs.applyForm
            },

            /**
             * 当前对话框的标题
             */
            title() {
                if (!this.currentOrder) {
                    return ''
                }
                return this.currentOrder.the_id + '   ' + this.currentOrder.order_base.base_id + ' 的采购信息'
            },

            /**
             * 当前的采购订单对象
             */
            currentOrder() {
                return this.currentApplyOrder
            },

            /**
             * 映射 store 中的数据到 computed 属性中
             */
            ...mapState(['currentApplyOrder']),
        },
        methods: {
            /**
             * 点击保存/更新采购
             */
            updateClick() {
                // 对表单进行验证
                // 传入一个箭头函数，处理表单的验证结果 validated {Boolean}
                this.formComponent.validate((validated) => {
                    // 验证通过
                    if (validated) {
                        this.updateLoading = true
                        this._sendUpdateRequest()
                    }
                })
            },

            /**
             * 发生更新请求
             */
            _sendUpdateRequest() {
                const url = `${this.$const.orderListUrl}${this.currentOrder.id}/apply_info/`
                this.updateLoading = true
                const data = {
                    applyinfo: {
                        // 将 Date 对象 转化为字符串
                        // 借助了 moment 模块
                        sub_material_estimate_date:
                            moment(this.modelData.sub_material_estimate_date).format(this.dateFormat),
                        estimate_date: moment(this.modelData.estimate_date).format(this.dateFormat),

                        sub_current: this.modelData.sub_current,
                        current: this.modelData.current,
                    }
                }

                // 发送 HTTP 请求
                this.$patchRequest(url, data)
                    .then(response => {
                        const order = response.data
                        this.setCurrentApplyOrder(order)
                        this.updateOrder(order)
                        this.msgSuccess('保存成功!')
                        this.updateLoading = false

                        // 如果采购部分已经完成，则从当前列表中移除[并更新其它控制台 order 信息]
                        if (order.applyinfo.finish) {
                            this.removeApplyOrders({
                                orders: [order],
                                update: true,
                            })
                            this.close()
                        }

                    })
                    .catch(error => {
                        this.updateLoading = false
                    })
            },

            /**
             * 关闭当前对话框
             */
            close() {
                this.show = false
            },

            /**
             * 打开当前对话框
             */
            open() {
                this.show = true
            },

            /**
             * 关闭当前对话框完成后的处理
             */
            closed() {
                this.formComponent.clearValidate()
            },

            /**
             * 初始化/重置 表单数据
             */
            initModelData() {
                if (this.currentOrder.applyinfo) {
                    for (let key in this.modelData) {
                        this.modelData[key] = this.currentOrder.applyinfo[key]
                    }
                }
            },

            /**
             * 弹出成功类型的信息
             */
            msgSuccess(message) {
                this.$message({
                    type: 'success',
                    showClose: true,
                    message,
                })
            },
            ...mapMutations(['setCurrentApplyOrder', 'removeApplyOrders', 'updateOrder'])
        },
        watch: {
            /**
             * 监控 currentOrder 发生变化
             * 则重置表单数据
             */
            currentOrder() {
                this.initModelData()
            },
        },
    }
</script>

<style scoped>
    >>> .__button-row button {
        float: left;
        margin-left: 10px;
    }
</style>
